import { useTranslation } from "react-i18next";
import CheckIcon from "@mui/icons-material/Check";
import { KeyboardArrowDown, KeyboardArrowRight } from "@mui/icons-material";

import styles from "./FilterSection.module.scss";

import localesKeys from "../../../locales/localesKeys.json";

const FilterSection = ({
  config,
  filters,
  currentPage,
  setFilters,
  handleGetBooks,
  isFilterOpen,
  setIsFilterOpen,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  return (
    <div
      className={
        styles.filterContainer +
        " " +
        (isFilterOpen ? styles.tabsActiveFilter : "")
      }
      onClick={() => setIsFilterOpen(!isFilterOpen)}
    >
      <div
        className={styles.filterSectionContainer}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.tabHeader}>
          <button onClick={() => setIsFilterOpen(!isFilterOpen)}>
            {t(localesKeys.CLOSE)}
          </button>
        </div>

        <div className={styles.filterList}>
          {config.map(
            ({ label, name, options, onExpand, onCheckBoxMarked }, index) =>
              options?.length ? (
                <div key={index} className={styles.filterSection}>
                  <div
                    className={styles.filterHeader}
                    onClick={() => onExpand()}
                  >
                    {label}
                    <span>
                      {filters?.expandes?.includes(name) ? (
                        <KeyboardArrowDown className={styles.icon} />
                      ) : (
                        <KeyboardArrowRight className={styles.icon} />
                      )}
                    </span>
                  </div>
                  {filters?.expandes?.includes(name) &&
                  name &&
                  options?.length ? (
                    <div className={styles.filterOptions}>
                      {options.map((item, idx) => (
                        <label key={idx} className={styles.checkboxLabel}>
                          <button
                            className={`${styles.checkBoxButton} ${
                              filters?.[name]?.includes(item?.value)
                                ? styles.active
                                : ``
                            }`}
                            onClick={() => onCheckBoxMarked(item?.value)}
                          >
                            <CheckIcon className={styles.checkIcon} />
                          </button>
                          {item?.isLang
                            ? item?.label?.[language]
                              ? item?.label?.[language]
                              : ""
                            : item?.label
                            ? item?.label
                            : ""}
                        </label>
                      ))}
                    </div>
                  ) : null}
                </div>
              ) : null
          )}
        </div>
      </div>
    </div>
  );
};
export default FilterSection;
